export default function getFormattedNote(rawText: string | null | undefined): string {
    if (rawText === null || rawText === undefined) {
        return '';
    }
    return rawText;
}